const navDirty = {
  state: {
    dirty: false
  },
  mutations: {
    SET_NAV_DIRTY(state, dirty) {
      state.dirty = !!dirty
    }
  }
}
export default navDirty
